import { render } from "./gameCreator.vue?vue&type=template&id=53464840&scoped=true"
import script from "./gameCreator.vue?vue&type=script&lang=js"
export * from "./gameCreator.vue?vue&type=script&lang=js"

import "./gameCreator.vue?vue&type=style&index=0&id=53464840&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53464840"]])

export default __exports__